import React, { useState } from 'react'
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";


const Contact = () => {
    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };
    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_vo7weev",
                "template_1x6nr8m",
                "#myForm",
                "RnYOVlDPnYyYN8khd"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");
                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/img/breadcrumb/breadcrumb.jpg)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Contact Us</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">Contact Us</li>
                    </ul>
                </div>
            </div>


            <div className="contact-area py-120">
                <div className="container">
                    <div className="contact-wrapper">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="contact-img">
                                    <img className='rounded' src="assets/img/contact/contact.jpg" alt />

                                </div>
                            </div>
                            <div className="col-md-6 align-self-center">
                                <div className="contact-form">
                                    <div className="contact-form-header">
                                        <h2>CONTACT US</h2>
                                        <p>We’d Love to Hear From You </p>
                                    </div>
                                    <form method="post" onSubmit={sendEmail} id="myForm" >
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Your Name"
                                                        name="from_name"
                                                        onChange={(e) => nameChange(e)}
                                                        required
                                                        value={name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input type="email" className="form-control" placeholder="Your Email"
                                                        name='email'
                                                        onChange={(e) => mailChange(e)}
                                                        value={mail}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <input type="number" className="form-control" placeholder="Your Phone"
                                                name='phone'
                                                onChange={(e) => numberChange(e)}
                                                value={number}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <textarea cols={30} rows={5} className="form-control" placeholder="Write Your Message"
                                                onChange={(e) => massagesChange(e)}
                                                name='massage'
                                                value={massages}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="theme-btn"> <i className="far fa-paper-plane" />Send Message
                                        </button>
                                        <div className="col-md-12 mt-3">
                                            <div className="form-messege text-success" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-120">
                        <div className="col-md-6">
                            <div className="contact-content">
                                <div className="contact-info">
                                    <i className="fal fa-map-marker-alt" />
                                    <div>
                                        <h5>Office Address</h5>
                                        <a href='https://share.google/rimdLRB3ORLnDqlf6'>
                                            <p>Pillar Number 143, # 49 & 50,<br />
                                                4th Floor, United Arcade,
                                                Attapur,<br /> Hyderabad,
                                                Telangana-500048</p>
                                        </a>
                                    </div>
                                </div>
                                <div className="contact-info">
                                    <i className="fal fa-phone" />
                                    <div>
                                        <h5>Call Us</h5>
                                        <a href="tel: 8008009832">
                                            (+91) 800 800 9832
                                        </a>
                                    </div>
                                </div>
                                <div className="contact-info">
                                    <i className="fal fa-envelope" />
                                    <div className='mail'>
                                        <h5>Email Us</h5>
                                        <a
                                            href="mailto:javid@spacedesignstudio.co.in"
                                            class="mail"
                                        >
                                            javid@spacedesignstudio.co.in
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=800&height=400&hl=en&q=Space Design Studio, Pillar N, United Arcade, Attapur, Telangana 500048&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://pdflist.com/" alt="pdflist.com">Pdflist.com</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>

                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Contact